/**
 * 工具类
 *
 * 修改了以前的对象的方式，以前各方法作为对象属性，问题在打包（build）后，会把整个对象打进去。
 * 现改用es6的模块方式，前端引用方法：
 *      import * as utils from '../utils.js';
 *      utils.formatTime();
 * 打包时webpack的tree-shaking会只处理被引用的方法；
 */

/**
 * @desc 函数防抖
 * @param fn 函数
 * @param timerDelay 延迟执行毫秒数
 * @param immediate true 表立即执行，false 表非立即执行
 */
export function debounce(fn, timerDelay, immediate) {
  let timer;
  return function () {
    let that = this;
    let args = arguments;

    if (timer) clearTimeout(timer);
    if (immediate) {
      var callNow = !timer;
      timer = setTimeout(() => {
        timer = null;
      }, timerDelay)
      if (callNow) fn.apply(that, args)
    } else {
      timer = setTimeout(function () {
        fn.apply(that, args)
      }, timerDelay);
    }
  }
}

// 节流
export function throttle(func, t) {
  let previous = 0, time = Number(t) || 1000;
  return function () {
    const now = new Date().getTime()
    if (previous + time <= now) {
      func.apply(this, arguments)
      previous = now
    }
  }
}

// export function throttle(fn, delay) {
//   let now, lastExec, timer, context, args; //eslint-disable-line
//
//   let execute = function () {
//     fn.apply(context, args);
//     lastExec = now;
//   };
//
//   return function () {
//     context = this;
//     args = arguments;
//
//     now = Date.now();
//
//     if (timer) {
//       clearTimeout(timer);
//       timer = null;
//     }
//
//     if (lastExec) {
//       let diff = delay - (now - lastExec);
//       if (diff < 0) {
//         execute();
//       } else {
//         timer = setTimeout(() => {
//           execute();
//         }, diff);
//       }
//     } else {
//       execute();
//     }
//   };
// }


/** ==================== 时间函数 ==================== */
/**
 * 时间转化
 * time 时间毫秒数,必传
 * format 格式,非必传 yyyy年 MM月 dd日 hh小时 mm分 ss秒，比如传入'始于yyyy-MM-dd的hh:mm',则返回'始于2014-06-15的12:05'
 *
 * 添加了毫秒格式, 用于logger.
 * 添加了星期格式, 用于酒店, 做了'今天'的判断.
 * ios下new Date(2016-10-31)报错:invalid date...要改为: 2016/10/31样式
 * */
export function formatTime(time, format) {
  if (!time) {
    return '';
  }
  if (typeof time === 'string') {
    time = time.toString().replace(/-/g, '/'); // ios下new Date(2016-10-31)报错:invalid date...要改为: 2016/10/31样式
  }
  if (typeof time === 'number' && time.toString().length === 10) {
    time = parseInt(time + '000');
  }
  // 过去
  var stamp = new Date(time),
    cur = new Date(),
    year = stamp.getFullYear(),
    month = stamp.getMonth() + 1 > 9 ? stamp.getMonth() + 1 : '0' + (stamp.getMonth() + 1),
    day = stamp.getDate() > 9 ? stamp.getDate() : '0' + stamp.getDate(),
    hour = stamp.getHours() > 9 ? stamp.getHours() : '0' + stamp.getHours(),
    minute = stamp.getMinutes() > 9 ? stamp.getMinutes() : '0' + stamp.getMinutes(),
    sec = stamp.getSeconds() > 9 ? stamp.getSeconds() : '0' + stamp.getSeconds(),
    ms =
      stamp.getMilliseconds() < 100
        ? '0' + (stamp.getMilliseconds() < 10 ? '0' + stamp.getMilliseconds() : stamp.getMilliseconds())
        : stamp.getMilliseconds(),
    weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
    week = weeks[stamp.getDay()];
  if (format) {
    format = format.replace('yyyy', year);
    format = format.replace('MM', month);
    format = format.replace('dd', day);
    format = format.replace('hh', hour);
    format = format.replace('mm', minute);
    format = format.replace('ss', sec);
    format = format.replace('ms', ms);

    if (year === cur.getFullYear() && stamp.getMonth() === cur.getMonth() && stamp.getDate() === cur.getDate()) {
      week = '今天';
    }
    format = format.replace('week', week);
  } else {
    format = year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
  }

  return format;
}

/**
 * 把字符串、数字转换成时间对象
 */
export function dateTrans(dt) {
  if (typeof dt === 'string') {
    dt = dt.toString().replace(/-/g, '/'); // ios下new Date(2016-10-31)报错:invalid date...要改为: 2016/10/31样式
  }
  if (typeof dt === 'number' && dt.toString().length === 10) {
    dt = parseInt(dt + '000');
  }
  dt = new Date(dt);
  return dt;
}

/**
 * 时间是否同年、同月、同日的判断函数
 */
export function isSameYear(dt1, dt2) {
  if (!dt1 || !dt2) return false;
  dt1 = dt1 instanceof Date ? dt1 : this.dateTrans(dt1);
  dt2 = dt2 instanceof Date ? dt2 : this.dateTrans(dt2);
  return dt1.getFullYear() === dt2.getFullYear();
}

export function isSameMonth(dt1, dt2) {
  if (!dt1 || !dt2) return false;
  dt1 = dt1 instanceof Date ? dt1 : this.dateTrans(dt1);
  dt2 = dt2 instanceof Date ? dt2 : this.dateTrans(dt2);
  return dt1.getFullYear() === dt2.getFullYear() && dt1.getMonth() === dt2.getMonth();
}

export function isSameDay(dt1, dt2) {
  if (!dt1 || !dt2) return false;
  dt1 = dt1 instanceof Date ? dt1 : dateTrans(dt1);
  dt2 = dt2 instanceof Date ? dt2 : dateTrans(dt2);
  return dt1.getMonth() === dt2.getMonth() && dt1.getDate() === dt2.getDate();
}

export const daysInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
/** 闰年 */
export const getIsLeapYear = year => (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
export const getMonthComps = (month, year) => ({
  days: month === 2 && getIsLeapYear(year) ? 29 : daysInMonths[month - 1],
  month,
  year
});

/** 上周 */
export const getPrevWeekComps = (month, year, day) => {
  let dt = year && month && day ? new Date(year, month - 1, day) : new Date();
  dt.setDate(dt.getDate() - 7 + dt.getDay() - 3); // 这么写是为了从周三开始计算本月还是下月、上月。。。
  let comps = getMonthComps(dt.getMonth() + 1, dt.getFullYear());
  // console.log('=========== ', year, month, day, dt, comps);
  return {...comps, day: dt.getDate()};
};
/** 下周 */
export const getNextWeekComps = (month, year, day) => {
  let dt = year && month && day ? new Date(year, month - 1, day) : new Date();
  // console.log('=========== ', year, month, day, dt);
  dt.setDate(dt.getDate() + 7 - dt.getDay() + 3); // 这么写是为了从周三开始计算本月还是下月、上月。。。
  // console.log('=========== ', year, month, day, dt);
  let comps = getMonthComps(dt.getMonth() + 1, dt.getFullYear());
  // console.log('=========== ', year, month, day, dt, comps);
  return {...comps, day: dt.getDate()};
};
/** 上个月 */
export const getPrevMonthComps = (month, year) => {
  if (month === 1) return getMonthComps(12, year - 1);
  return getMonthComps(month - 1, year);
};

/** 下个月 */
// Day/month/year components for next month
export const getNextMonthComps = (month, year) => {
  if (month === 12) return getMonthComps(1, year + 1);
  return getMonthComps(month + 1, year);
};

/** ==================== 各种正则 ==================== */
/**
 * validator校验
 */
export function validateEmail(val) {
  let re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/; // (字母、数字、下划线、-、. )@(字母、数字、-)
  return re.test(val);
}

export function validateTel(val) {
  let re = /^0\d{2,3}-?\d{7,8}$/; // 0开头2~3位区号，可以加-（也可不加），加上7~8位数字
  return re.test(val);
}

export function validateMobile(val) {
  let re = /^1\d{10}$/; // 1开头的11位数字
  return re.test(val);
}

/**
 * 不允许输入特殊字符
 * */
export function validateText(val) {
  let re = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/;
  return re.test(val);
}

/**
 * 输入手机号的校验
 * */
export function validatePhone(val) {
  let re = /^0?1[3|4|5|7|8]\d{9}$/;
  return re.test(val);
}

/**
 * 数字
 * */
export function validateNumbers(val) {
  let re = /^[0-9]*$/;
  return re.test(val);
}

/**
 * 输入身份证号的校验
 * */
export function validateCard(val) {
  let re = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
  return re.test(val);
}

// /**
//  * 银行卡号校验
//  * */
// export function validateBank(val) {
//     return true;
// };

// 军人身份证验证：6-8位字母数字组合 刘俊俊 2018.9.12(产品张佳欣)
export function validateSorderIdenty(val) {
  let re = /^\s*\w{6,8}\s*$/;
  return re.test(val);
}

// 社会保障卡验证--10位数字--孙硕---2017-12-15；
export function validateSocialSecurityCard(val) {
  let re = /^\s*\d{10}\s*$/;
  return re.test(val);
}

// 港澳通行证验证--字母c后至少六位数字后的任意字符--孙硕---2017-12-15；
export function validateHongKongMacauPasser(val) {
  // let re = /^\s*[a-zA-Z]\d{6,12}\s*$/ig;
  let re = /^\s*[a-zA-Z]\d{6,}/;
  return re.test(val);
}

// 台湾居民来往大陆通行证验证--8位数字--孙硕---2017-12-15；
export function validateTaiwanPasser(val) {
  let re = /^\s*\d{8}\s*$/;
  return re.test(val);
}

// 户口本验证--9位数字
export function validateHouseHoldRegister(val) {
  let re = /^\s*\d{9}\s*$/;
  return re.test(val);
}

// 临时居民身份证验证--18位数字-
export function validateInterimId(val) {
  let re = /^\s*\d{18}\s*$/;
  return re.test(val);
}

// 护照验证
export function validatePassport(val) {
  let re = /^\s*[a-zA-Z0-9]{6,12}\s*$/;
  return re.test(val);
}

// 外国人永久居留证验证
export function permitForForeigners(val) {
  // 做有值校验
  return /\w+/.test(val);
}

export function getComputedStyle(el) {
  // return Vue.prototype.$isServer ? {} : document.defaultView.getComputedStyle(el);
  return document.defaultView.getComputedStyle(el);
}

export function toChinesNum(num) {
  let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']; //changeNum[0] = "零"
  let unit = ["", "十", "百", "千", "万"];
  num = parseInt(num);
  let getWan = (temp) => {
    let strArr = temp.toString().split("").reverse();
    let newNum = "";
    for (var i = 0; i < strArr.length; i++) {
      newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
    }
    return newNum;
  }
  let overWan = Math.floor(num / 10000);
  let noWan = num % 10000;
  if (noWan.toString().length < 4) noWan = "0" + noWan;
  return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
}

/*
 * 功能：给图片URL地址增加后缀
 * 解决问题：
 *   首次加载：接收req.headers.accept的值，确认是否有'image/webp'
 *       如果有：支持webp，给对应的webp图
 *       没有：则不支持webp，要啥图给啥图
 *   浏览器中的路由切换：判断浏览器是否支持webp
 *       如果有：支持webp，给对应的webp图
 *       没有：则不支持webp，要啥图给啥图
 *
 * 功能：对图片进行处理（阿里云）
 * @param string url 文件名
 * @param Object {}  参数
 *   width: 图片宽度
 *   height: 图片高度
 *
 * 调整type参数，兼容默认引用;
 * 默认png不做处理，如确定不需要透底，可指定type=jpg，进行类型转后后再启用渐进方案；
 *               -- Mod by Dio sunleqing. on 2019.5.24
 **/
export function format(url, {width = 0, height = 0, type = '', thumb = false} = {}) {
  // 请求过程中，有undefined, ''等URL地址，返回默认图片
  if (!url) return 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

  // 有地址会被两次处理
  // console.error(url, url.indexOf('x-oss-process') >= 0 || url.indexOf('!/') >= 0);
  if (url.indexOf('x-oss-process') >= 0 || url.indexOf('!/') >= 0) return url;

  // 判断是否支持webp
  let webp = getLocalStorage().get('webp-is-supported') || false;

  // 避免https下访问http图片会报警告（后台存储的sku图片等）。
  url = url.replace('http://', '//').replace('https://', '//');

  // 获取URL地址后的后缀名
  const newType = url.slice(url.lastIndexOf('.') + 1);

  // window.alert(url);
  // window.alert(/upyun-img/.test(url));
  if (/upaiyun.com/.test(url) || /upyun-img/.test(url)) {
    // 又拍云
    if (thumb) return url + '!/fw/50' + (newType === 'png' ? '' : '/gaussblur/5x5'); // 返回缩略图
    let tmp = '!';

    // 2. 格式转换 非空 && (非webp格式 || webp && 支持webp)
    if (webp) {
      // 如果浏览器支持webp，使用webp格式
      tmp += '/format/webp';
    } else if (type || (!type && newType === 'png')) {
      // 如果传入了类型转换 || (未指定类型转换 && 当前url为png类型)
      if (!type && newType === 'png') type = newType; // 默认png不指定类型转换是看不到渐进效果的，这里这么写是为了兼容。 Mod by Dio Zhu. on 2018.8.10
      tmp += `/format/${type}/progressive/true`;
    } else {
      // 默认所有图片都转换为jpg、渐进
      tmp += '/format/jpg/progressive/true';
    }

    // 1. 宽高
    if (width && height) tmp += '/both/' + width + 'x' + height;
    else if (width) tmp += '/fw/' + width;
    else if (height) tmp += '/fh/' + height;

    let newQuery = tmp === '!' ? '' : tmp;
    return url + newQuery;
  } else if (/aliyuncs.com|static.91wuliu.com/.test(url)) {
    // 阿里云oss（自有域名：s01.dongyin.net）
    // console.warn(url, thumb);
    if (thumb)
      return url + '?x-oss-process=image/format,webp/resize,w_51' + (newType === 'png' ? '' : '/blur,r_5,s_5'); // 返回缩略图
    let tmp = '';

    // 1. 针对宽高处理
    if (width) tmp = `/resize,w_${width}`;
    if (height) tmp = `/resize,h_${height}`;
    if (width && height) tmp = `/resize,m_fill,w_${width},h_${height}`;

    // 2. 格式转换 非空 && (非webp格式 || webp && 支持webp)
    if (webp) {
      // 如果浏览器支持webp，使用webp格式
      tmp += '/format,webp';
    } else if (type || (!type && newType === 'png')) {
      // 如果传入了类型转换 || (未指定类型转换 && 当前url为png类型)
      if (!type && newType === 'png') type = newType; // 默认png不指定类型转换是看不到渐进效果的，这里这么写是为了兼容。 Mod by Dio Zhu. on 2018.8.10
      tmp += `/format,${type}/interlace,1`;
    } else {
      // 默认所有图片都转换为jpg、渐进
      tmp += '/format,jpg/interlace,1';
    }

    // 3. 拼接新图片路径
    let newQuery = tmp === '' ? '' : '?x-oss-process=image' + tmp;
    return url + newQuery;
  } else {
    return url;
  }
}


/**
 * 将aa=bb&cc=dd 转换成对象并根据key 提取出值
 * @param name key
 * @param url url 地址
 * @returns {string | null}
 */
export function getQuery2object(key, url) {
  let arr = url.split('&')
  let obj = new Object();
  arr.forEach(v => {
    obj[v.split('=')[0]] = v.split('=')[1]
  })
  if (obj[key]) {
    if (obj[key].includes('{')) {
      return obj[key].replace('{', '').replace('}', '');
    } else {
      return obj[key];
    }
  } else {
    return ''
  }

}

/**
 *
 * @param base64 {String} 必传
 * @param fileName {any}
 * @param fileType {any}
 * @returns {File | Error}
 */
export function base64ToFile(base64, fileName, fileType) {
  if (typeof base64 !== 'string') {
    return new Error('base64 no string')
  }
  if (base64.startsWith('data:image')) {
    fileType = fileType ? fileType : base64.match(/:(.*?);/)[1] //image/png image/jpg
    const type = fileName ? fileName : fileType.split('/')[1] //png jpg
    fileName = fileName ? fileName : `${Date.now()}.${type}`
    base64 = base64.split(',')[1]
  } else {
    fileName = `${Date.now()}.jpg`
    fileType = 'image/jpg'
  }

  //1.将base64 解码
  base64 = atob(base64)
  //2.获取二进制数据
  const arr = [...base64].map(str => str.charCodeAt(0))
  const unitArray = Uint8Array.from(arr)
  //3.创建文件返回
  return new File([unitArray], fileName, {type: fileType})
}

import parseAPNG from 'apng-js'

/**
 * @param img 图片对象
 * @param mCanvas Canvas对象
 * @param options
 * @returns {Promise<unknown>}
 */
export async function imageAnimationLoad(img, mCanvas, options = {}) {
  if (!img || !img.src) {
    return Promise.reject()
  }
  const blob = await fetch(img.src).then(res => res.blob());
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(blob);
    reader.onload = async () => {
      const imgBuffer = reader.result
      mCanvas.height = img.height
      mCanvas.width = img.width
      const ctx = mCanvas.getContext('2d')
      const apng = parseAPNG(imgBuffer);
      Object.keys(options).forEach(key => apng[key] = options[key])
      const player = await apng.getPlayer(ctx);
      resolve(player)
    };
  })
}

/**
 * 图片压缩的方法
 * @param imgPath 图片文件的路径
 * @param width 图片宽度，0表示根据高度按比例
 * @param height 图片高度，0表示根据宽度按比例
 * @param quality 质量
 * @param callback 回调函数
 */
export function imageCompress(imgPath, width, height, callback) {
  photoCompress(imgPath, width, height, 1, callback)
}

export function photoCompress(imgPath, width, height, quality = 1, callback) {
  let obj = {
    width,
    height,
    quality
  }
  if (String(obj.width) === '0') delete obj.width;
  if (String(obj.height) === '0') delete obj.height;
  canvasDataURL(imgPath, obj, callback);
}

export function canvasDataURL(imgPath, obj, callback) {
  let img = new Image();
  img.src = imgPath;
  img.crossOrigin = "anonymous"; //关键
  img.onload = (e) => {
    // 默认按比例压缩
    let width = e.width
    let height = e.height
    let scale = width / height;
    width = obj.width || width;
    height = obj.height || (width / scale);
    let quality = 1; // 默认图片质量为1
    //生成canvas
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');
    // 创建属性节点
    let anw = document.createAttribute("width");
    anw.nodeValue = width;
    let anh = document.createAttribute("height");
    anh.nodeValue = height;
    canvas.setAttributeNode(anw);
    canvas.setAttributeNode(anh);
    ctx.drawImage(img, 0, 0, width, height);
    // 图像质量
    if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
      quality = obj.quality;
    }
    let base64 = canvas.toDataURL('image/png', quality);
    canvas = null;
    // 回调函数返回base64的值
    callback && callback(base64, imgPath);
  }
}

/**
 * 根据文件类型获取icon图标
 * @param url 文件url
 * @returns {*}
 */
export function getFileTypeForIcon(url = '') {
  const excelList = ['xlsx', 'xls']
  const pdfList = ['pdf']
  const audioList = ['mp3']
  const videoList = ['asx', 'asf', 'mpg', '3pg', 'mp4', 'mov', 'avi', 'flv']
  const pptList = ['pptx', 'ppt']
  const wordList = ['doc', 'docx']
  const wpsList = ['wps', 'wpsx']
  const txtList = ['txt']

  if (url && typeof url === 'string') {
    let type = url.split('.').pop()
    if (type) {
      type = type.toLowerCase()
      if (excelList.includes(type)) return require('../../src/assets/image/fileType/excel.png');
      if (pdfList.includes(type)) return require('../../src/assets/image/fileType/pdf.png');
      if (audioList.includes(type)) return require('../../src/assets/image/fileType/audio.png');
      if (videoList.includes(type)) return require('../../src/assets/image/fileType/video.png');
      if (wordList.includes(type)) return require('../../src/assets/image/fileType/word.png');
      if (wpsList.includes(type)) return require('../../src/assets/image/fileType/wps.png');
      if (txtList.includes(type)) return require('../../src/assets/image/fileType/txt.png');
      if (pptList.includes(type)) return require('../../src/assets/image/fileType/ppt.png');
    }
  }
  return require('../../src/assets/image/fileType/other.png');
}

/**
 * 发送剪切板数据到iframe中的OS
 * @param iframeOrFun iframe对象
 * @param requirement 条件
 */
export async function sendClipboardContent(iframeOrFun, requirement = true) {
  let clipboardContent = null
  const time = 500
  return await navigator.permissions.query({name: 'clipboard-read'}).then(result => {
    return setInterval(() => {
      const hasFocus = document.hasFocus()
      if (hasFocus && (result.state === 'granted' || result.state === 'prompt')) {
        const clipboard = navigator.clipboard.readText()
        clipboard.then(clipText => {
          if (clipText !== clipboardContent && clipText) {
            clipboardContent = clipText
            const require = typeof requirement === 'function' ? requirement() : requirement;
            if (iframeOrFun instanceof HTMLIFrameElement) {
              console.log('发送消息', clipboardContent)
              require && iframeOrFun.contentWindow.postMessage({
                gxzl: true,
                type: 'copy',
                params: {content: clipText}
              }, iframeOrFun.src);
            } else if (typeof iframeOrFun === 'function') {
              require && iframeOrFun(clipboardContent)
              console.log('返回消息', clipboardContent)
            }
          }
        })
      }
    }, time)
  })
}

/**
 * 兼容linuxLabOS寫錯的問題
 * @param str
 * @returns {boolean}
 */
export function isLinuxLabOS(str) {
  return ['liunxLabOS', 'linuxLabOS'].includes(str)
}

/**
 * 生成图片
 * @param el
 * @param scale //定义任意放大倍数 支持小数
 * @returns {Promise<string>}
 */
import html2canvas from "html2canvas";

export async function generatePictures(el = document.body, scale = window.devicePixelRatio) {
  // allowTaint: true,
  return html2canvas(el, {
    scale,
    useCORS: true,
    logging: false
  }).then(canvas => Promise.resolve(canvas.toDataURL('image/png')));
}


import kscreenshot from "kscreenshot";

/**
 * 部分截图
 * @returns {Promise<void>}
 */
export async function execPartScreenshot() {
  return execScreenshot('part', null, null, window.devicePixelRatio * 2)
}

/**
 * 完整截图
 * 如果 drawingBoardEl 和 backgroundRequired都存在的情况下 返回数组
 * @param drawingBoardEl 画板element元素 canvas、div等
 * @param backgroundRequired  是否需要背景图 boolean
 * @returns {Promise<String[]>}
 */
export async function execWholeScreenshot(drawingBoardEl, backgroundRequired) {
  return execScreenshot('whole', drawingBoardEl, backgroundRequired)
}

/**
 * @param model whole:完整截图 part:部分截图
 * @param drawingBoardEl 画板element元素
 * @param backgroundRequired 是否需要背景图
 * @param scale 放大倍率
 */
export async function execScreenshot(model = 'part', drawingBoardEl, backgroundRequired, scale = window.devicePixelRatio) {
  let video = document.createElement('video');
  let canvas = document.createElement('canvas');
  let app = document.getElementById('app');
  let isDouble = drawingBoardEl && backgroundRequired;
  const screenshot = navigator.mediaDevices.getDisplayMedia({
    audio: false,
    video: {width: window.screen.width * scale, height: window.screen.height * scale},
    preferCurrentTab: true
  }).then(stream => {
    let tracks = stream.getTracks() || [];
    const stop = () => tracks.forEach(track => track && track.stop());
    let track = tracks[0];
    if (track) {
      const settings = track.getSettings();
      if (settings.displaySurface && settings.displaySurface !== 'browser') {
        stop();
        return Promise.reject({type: 'screenshot', code: -1});
      }
    }

    const promise = new Promise((resolve, reject) => {
      video.srcObject = stream;
      video.onloadedmetadata = () => video.play();
      video.onloadeddata = () => {
        canvas.height = video.videoHeight * scale;
        canvas.width = video.videoWidth * scale;
        canvas.style.height = document.body.offsetHeight - 8 + 'px';
        canvas.style.width = document.body.offsetWidth - 8 + 'px';
        let d2 = canvas.getContext('2d');
        d2.drawImage(video, 0, 0, canvas.width, canvas.height);
        //执行截图
        if (model === 'whole') {//完整截图
          setTimeout(() => {
            let images = [canvas.toDataURL()];
            //如果存在画板 并需要背景图 也就是说需要两张图片
            if (isDouble) {
              drawingBoardEl.style.display = 'none'
              setTimeout(() => {
                d2.drawImage(video, 0, 0, canvas.width, canvas.height);
                setTimeout(() => {
                  images.push(canvas.toDataURL());
                  console.log('images:', images);
                  drawingBoardEl.style.display = ''
                  resolve(images);
                }, 200)

              }, 200)
            } else {
              resolve(canvas.toDataURL());
            }
            console.log('whole 截图完成');
          }, 200)
        } else if (model === 'part') {//部分截图
          stop();
          app.style.display = 'none';
          canvas.style.position = 'fixed'
          canvas.style.top = '0'
          canvas.style.left = '0'
          canvas.style.zIndex = '9999'
          document.body.appendChild(canvas);
          let screenshot = new kscreenshot({});
          const options = {
            needDownload: false,
            endCB: (base64) => { //截图成功回调
              console.log('part 截图完成');
              resolve(base64);
            },
            cancelCB(e) { //截图失败回调
              reject(e);
            }
          }
          Object.assign(screenshot, options);
          screenshot['startScreenShot']();
        }
      }
    })
    promise.finally(() => {
      stop();
      video.remove();
      canvas.remove();
      app.style.display = '';
      app.style.cursor = '';
    })
    return promise
  })
  screenshot.catch(error => console.log('截图取消', error));
  return screenshot;
}

/**
 * 开启全屏
 * @param element
 */
export function launchFullScreen(element) {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  }
}

/**
 * 关闭全屏
 */
export function exitFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
}

/**
 * 简单的中间文字脱敏
 * @param text 文本
 * @param threshold 阀值
 * @returns {string}
 */
export function desensitization(text = '', threshold = 1.51) {
  if (typeof text !== "string" && typeof text !== "number" || text == null) return ''
  text = String(text)
  const length = text.length
  const hideNum = Math.floor(length / threshold)
  let start = Math.ceil((length - hideNum) / 2)
  let end = Math.floor((length - hideNum) / 2)
  return text.slice(0, start) + '*'.repeat(length - start - end) + text.slice(length - end, length)
}

/**
 * 公用的下载文件 方法。
 * @param url  文件地址
 * @param rename  文件名称
 */
export function downloadFun(url, rename = ''){
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.setAttribute('download', rename);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

/**
 *  处理JSON中的超过12位数值 ，解决超过16位数字解析精度丢失问题
 */
import JSONBIG from 'json-bigint';
export function setJsonBig(data){
  const json = JSONBIG({
    storeAsString: true
  })
  if (!data) return ''
  try {
    return json.parse(data)
  }catch (e) {
    return data
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js